import { render, staticRenderFns } from "./ProductConfirmation.vue?vue&type=template&id=79fe8c4f"
import script from "./ProductConfirmation.vue?vue&type=script&lang=js"
export * from "./ProductConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports